/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Denotation } from './Denotation';
import {
    DenotationFromJSON,
    DenotationFromJSONTyped,
    DenotationToJSON,
} from './Denotation';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';
import type { Info } from './Info';
import {
    InfoFromJSON,
    InfoFromJSONTyped,
    InfoToJSON,
} from './Info';

/**
 * List of all groups, in order
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    visible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    label: string;
    /**
     * 
     * @type {Denotation}
     * @memberof Group
     */
    denotation?: Denotation;
    /**
     * 
     * @type {IconRef}
     * @memberof Group
     */
    icon?: IconRef;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    title?: string;
    /**
     * The single properties of this Group, in order
     * @type {Array<Info>}
     * @memberof Group
     */
    infos: Array<Info>;
}

/**
 * Check if a given object implements the Group interface.
 */
export function instanceOfGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "infos" in value;

    return isInstance;
}

export function GroupFromJSON(json: any): Group {
    return GroupFromJSONTyped(json, false);
}

export function GroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): Group {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'visible': !exists(json, 'visible') ? undefined : json['visible'],
        'label': json['label'],
        'denotation': !exists(json, 'denotation') ? undefined : DenotationFromJSON(json['denotation']),
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
        'id': json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'infos': ((json['infos'] as Array<any>).map(InfoFromJSON)),
    };
}

export function GroupToJSON(value?: Group | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'visible': value.visible,
        'label': value.label,
        'denotation': DenotationToJSON(value.denotation),
        'icon': IconRefToJSON(value.icon),
        'id': value.id,
        'title': value.title,
        'infos': ((value.infos as Array<any>).map(InfoToJSON)),
    };
}

